(function () {
  var SIZE_NAME = /talla|size|tama|medida|n[uú]mero/i;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function node(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text != null) el.textContent = text;
    return el;
  }

  function sizedUrl(src, width) {
    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (error) {
      return src;
    }
  }

  function formatMoney(cents) {
    var amount = Math.round(Number(cents) / 100);
    return '$' + amount.toLocaleString('en-US');
  }

  function sizesFor(product) {
    var options = product.options || [];
    var option = null;
    for (var i = 0; i < options.length; i++) {
      if (SIZE_NAME.test(options[i].name || '')) {
        option = options[i];
        break;
      }
    }
    if (!option && options.length === 1 && (product.variants || []).length > 1) option = options[0];
    if (!option) return null;

    var key = 'option' + option.position;
    return (option.values || [])
      .map(function (value) {
        var variant = (product.variants || []).find(function (item) {
          return item[key] === value;
        });
        if (!variant) return null;
        return { value: value, id: variant.id, available: !!variant.available };
      })
      .filter(Boolean);
  }

  function singleVariant(product) {
    var available = (product.variants || []).filter(function (variant) {
      return variant.available;
    });
    if (available.length !== 1) return null;
    if ((product.variants || []).length === 1) return available[0];
    return null;
  }

  function initLook(root) {
    if (!root || root.dataset.rdReady === 'true') return;
    root.dataset.rdReady = 'true';

    var copyNode =
      (root.parentElement && root.parentElement.querySelector('[data-rd-look-copy]')) ||
      document.querySelector('[data-rd-look-copy]');
    var copy = {};
    try {
      copy = JSON.parse(copyNode ? copyNode.textContent : '{}');
    } catch (error) {
      copy = {};
    }

    var widget = root.parentElement.querySelector('.rd-look__widget');
    var skeleton = root.parentElement.querySelector('[data-rd-look-skeleton]');

    function hideSkeleton() {
      if (skeleton) skeleton.hidden = true;
    }

    var seed = root.dataset.seed;
    var collectionUrl = root.dataset.collectionUrl;

    var exclude = (root.dataset.exclude || '')
      .split(',')
      .filter(Boolean)
      .map(function (id) {
        return String(id);
      });

    function rrHasContent() {
      return !!(widget && widget.childElementCount > 0);
    }

    function cartVariantIds(cart) {
      var ids = {};
      (cart.items || []).forEach(function (item) {
        if (item.properties && item.properties._is_gift_bag === 'true') return;
        ids[String(item.variant_id)] = true;
      });
      return ids;
    }

    function resetSizeButton(button) {
      if (button.getAttribute('data-sold-out') === 'true') return;
      button.disabled = false;
      button.textContent = button.getAttribute('data-size') || '';
      button.removeAttribute('data-added');
    }

    function markAdded(button, label) {
      button.disabled = true;
      button.textContent = label;
      button.setAttribute('data-added', 'true');
    }

    function syncFromCart(cart) {
      var present = cartVariantIds(cart);
      var addedLabel = copy.added || 'Agregado';
      var addLabel = copy.add || 'Agregar';

      root.querySelectorAll('.rd-look__card').forEach(function (card) {
        var sizes = card.querySelectorAll('.rd-look__size');
        var add = card.querySelector('.rd-look__add');
        var prompt = card.querySelector('.rd-look__prompt');
        var list = card.querySelector('.rd-look__sizes');
        var status = card.querySelector('.rd-look__status');
        var stillThere = false;

        sizes.forEach(function (button) {
          var id = button.getAttribute('data-variant-id');
          if (present[id]) {
            stillThere = true;
            markAdded(button, addedLabel);
          } else if (button.getAttribute('data-added') === 'true') {
            resetSizeButton(button);
          }
        });

        if (add && add.getAttribute('data-variant-id')) {
          if (present[add.getAttribute('data-variant-id')]) {
            stillThere = true;
            markAdded(add, addedLabel);
          } else if (add.getAttribute('data-added') === 'true') {
            add.disabled = false;
            add.textContent = addLabel;
            add.removeAttribute('data-added');
          }
        }

        if (stillThere) {
          if (sizes.length && add) add.hidden = true;
          if (prompt) prompt.hidden = false;
          if (list) list.hidden = false;
          if (status) {
            status.textContent = addedLabel;
            status.classList.add('is-ok');
            status.hidden = false;
          }
          return;
        }

        var wasAdded = status && !status.hidden && status.classList.contains('is-ok');
        if (!wasAdded) return;

        sizes.forEach(resetSizeButton);
        if (add) {
          add.hidden = false;
          add.disabled = false;
          if (!add.getAttribute('data-variant-id')) add.textContent = addLabel;
        }
        if (prompt) prompt.hidden = true;
        if (list) list.hidden = true;
        if (status) {
          status.hidden = true;
          status.classList.remove('is-ok');
          status.textContent = '';
        }
      });
    }

    function publishCart(cart) {
      if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!root.isConnected) return;
        var cart = event && (event.cartData || event.cart_data);
        if (cart && cart.items) syncFromCart(cart);
      });
    }

    if (widget) {
      new MutationObserver(function () {
        if (!rrHasContent()) return;
        root.hidden = true;
        hideSkeleton();
      }).observe(widget, { childList: true, subtree: true });
    }

    if (rrHasContent()) hideSkeleton();

    function toCents(value) {
      var amount = parseFloat(value);
      if (!isFinite(amount) || amount <= 0) return null;
      return Math.round(amount * 100);
    }

    function fromCollection(product) {
      var image = product.images && product.images[0] ? product.images[0].src : '';
      var variants = (product.variants || []).map(function (variant) {
        return {
          id: variant.id,
          available: !!variant.available,
          option1: variant.option1,
          option2: variant.option2,
          option3: variant.option3,
          price: toCents(variant.price),
          compare_at_price: toCents(variant.compare_at_price),
        };
      });
      var current = variants.filter(function (variant) {
        return variant.available;
      })[0] || variants[0];
      return {
        id: product.id,
        title: product.title,
        handle: product.handle,
        available: variants.some(function (variant) {
          return variant.available;
        }),
        featured_image: image,
        price: current ? current.price : null,
        compare_at_price: current ? current.compare_at_price : null,
        options: product.options || [],
        variants: variants,
      };
    }

    var productsPromise = seed
      ? fetch(root.dataset.url + '?product_id=' + encodeURIComponent(seed) + '&limit=12&intent=related')
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            return (data.products || []).filter(function (product) {
              return exclude.indexOf(String(product.id)) === -1 && product.available;
            }).slice(0, 8);
          })
      : collectionUrl
        ? fetch(collectionUrl + (collectionUrl.indexOf('?') === -1 ? '?' : '&') + 'limit=12')
            .then(function (response) {
              if (!response.ok) throw new Error('collection');
              return response.json();
            })
            .then(function (data) {
              return (data.products || []).map(fromCollection).filter(function (product) {
                return product.available;
              }).slice(0, 8);
            })
        : Promise.resolve([]);

    productsPromise = productsPromise.catch(function () {
      return [];
    });

    Promise.all([
      productsPromise,
      new Promise(function (resolve) {
        window.setTimeout(function () {
          resolve(rrHasContent());
        }, 1500);
      }),
    ]).then(function (result) {
      var products = result[0];
      var filled = result[1] || rrHasContent();
      if (filled || !products.length) {
        hideSkeleton();
        return;
      }
      render(products);
    });

    function render(products) {
      var track = root.querySelector('[data-rd-look-track]');
      var scope = root.closest('.rd-look') || root;
      var prev = scope.querySelector('[data-rd-look-prev]');
      var next = scope.querySelector('[data-rd-look-next]');
      var nav = scope.querySelector('[data-rd-look-nav]');
      products.forEach(function (product) {
        track.appendChild(card(product));
      });
      hideSkeleton();
      root.hidden = false;
      if (nav) nav.hidden = false;

      function step() {
        var item = track.querySelector('.rd-look__card');
        return item ? item.getBoundingClientRect().width + 12 : track.clientWidth;
      }

      function updateNav() {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();

      fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js')
        .then(function (response) {
          return response.json();
        })
        .then(syncFromCart)
        .catch(function () {});
    }

    function card(product) {
      var article = node('article', 'rd-look__card');
      var href = '/products/' + product.handle;
      var imageUrl = product.featured_image || '';
      if (imageUrl.indexOf('//') === 0) imageUrl = 'https:' + imageUrl;

      var media = node('a', 'rd-look__media');
      media.href = href;
      if (imageUrl) {
        var image = node('img');
        image.src = sizedUrl(imageUrl, 450);
        image.srcset = [300, 450, 600]
          .map(function (width) {
            return sizedUrl(imageUrl, width) + ' ' + width + 'w';
          })
          .join(', ');
        image.sizes = '(min-width: 750px) 220px, 66vw';
        image.width = 450;
        image.height = 600;
        image.alt = product.title || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        media.appendChild(image);
      }

      var name = node('a', 'rd-look__name', product.title || '');
      name.href = href;

      var price = node('div', 'rd-look__price');
      if (product.compare_at_price && product.compare_at_price > product.price) {
        price.appendChild(node('s', 'rd-look__compare', formatMoney(product.compare_at_price)));
      }
      price.appendChild(node('span', 'rd-look__final', formatMoney(product.price)));

      var status = node('p', 'rd-look__status');
      status.hidden = true;

      var meta = node('div', 'rd-look__meta');
      meta.append(name, price);
      article.append(media, meta);

      var sizes = sizesFor(product);
      if (sizes && sizes.length) {
        var prompt = node('p', 'rd-look__prompt', copy.chooseSize || 'Elige tu talla');
        var list = node('div', 'rd-look__sizes');
        prompt.hidden = true;
        list.hidden = true;

        var add = node('button', 'rd-look__add', copy.add || 'Agregar');
        add.type = 'button';
        add.addEventListener('click', function () {
          prompt.hidden = false;
          list.hidden = false;
          add.hidden = true;
          status.hidden = true;
        });

        sizes.forEach(function (size) {
          var button = node('button', 'rd-look__size', size.value);
          button.type = 'button';
          button.setAttribute('data-variant-id', String(size.id));
          button.setAttribute('data-size', size.value);
          if (!size.available) {
            button.disabled = true;
            button.setAttribute('data-sold-out', 'true');
            button.title = copy.soldOut || 'Agotada';
          } else {
            button.addEventListener('click', function () {
              addVariant(size.id, button, status, copy);
            });
          }
          list.appendChild(button);
        });

        article.append(add, prompt, list, status);
      } else {
        var only = singleVariant(product);
        if (only) {
          var direct = node('button', 'rd-look__add', copy.add || 'Agregar');
          direct.type = 'button';
          direct.setAttribute('data-variant-id', String(only.id));
          direct.addEventListener('click', function () {
            addVariant(only.id, direct, status, copy);
          });
          article.append(direct, status);
        }
      }

      return article;
    }

    function addVariant(id, button, status, labels) {
      button.disabled = true;
      status.hidden = true;
      status.classList.remove('is-ok');

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add');
          var cartItems = document.querySelector('cart-items');
          if (cartItems && typeof cartItems.onCartUpdate === 'function') return cartItems.onCartUpdate();
          var drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function') return;
          if (document.body.classList.contains('template-cart')) return;
          return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
            .then(function (sectionResponse) {
              return sectionResponse.json();
            })
            .then(function (sections) {
              drawer.renderContents({ sections: sections });
            })
            .catch(function () {});
        })
        .then(function () {
          return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js').then(function (response) {
            return response.json();
          });
        })
        .then(function (cart) {
          publishCart(cart);
          if (root.isConnected) syncFromCart(cart);
          if (!button.isConnected) return;
          status.textContent = labels.added || 'Agregado';
          status.classList.add('is-ok');
          status.hidden = false;
        })
        .catch(function () {
          button.disabled = false;
          status.textContent = labels.error || '';
          status.hidden = false;
        });
    }
  }

  function initLooks() {
    var onCartPage = document.body.classList.contains('template-cart');
    document.querySelectorAll('[data-rd-look]').forEach(function (root) {
      if (onCartPage && root.closest('cart-drawer')) return;
      initLook(root);
    });
  }

  function drawerLook() {
    return document.querySelector('cart-drawer .rd-look--drawer');
  }

  function lookKey(look) {
    var carousel = look && look.querySelector('[data-rd-look]');
    return carousel ? carousel.dataset.seed || '' : null;
  }

  // Runs a drawer re-render and puts back the already loaded carousel when the
  // recommendations would be the same (e.g. adding the gift bag), so it doesn't reload.
  function keepDrawerLook(render) {
    var previous = drawerLook();
    var result = render();
    var restore = function () {
      var fresh = drawerLook();
      if (!previous || !fresh || previous === fresh) return;
      var carousel = previous.querySelector('[data-rd-look]');
      if (!carousel || carousel.dataset.rdReady !== 'true') return;
      if (lookKey(previous) !== lookKey(fresh)) return;
      fresh.replaceWith(previous);
    };
    if (result && typeof result.then === 'function') {
      return result.then(function (value) {
        restore();
        return value;
      });
    }
    restore();
    return result;
  }

  window.rdInitLooks = initLooks;
  window.rdKeepDrawerLook = keepDrawerLook;
  ready(initLooks);
})();
